import { Globals } from '../../modules/Globals';
import axios from 'axios';
import IVariable from '../../interfaces/IVariable';
import { IOrder } from '../../interfaces/IOrder';
import { serializeQuery } from '../../utils';

const apiUrl = Globals.apiPath + '/restaurantVariables';

export default class RestaurantVariablesService {
  constructor() {}

  static async get({
    restaurantId,
    branchId,
    category,
    key,
  }: {
    restaurantId: number;
    branchId?: number | null;
    category?: string;
    key?: string;
  }): Promise<Array<IVariable<any>>> {
    let res = await axios.get<Array<IVariable<any>>>(
      `${apiUrl}?${serializeQuery({
        r: restaurantId,
        b: branchId,
        cat: category,
        key,
      })}`
    );
    return res.data;
  }

  static async set({
    restaurantId,
    branchId,
    category,
    key,
    value,
  }: {
    restaurantId: number;
    branchId?: number | null;
    category: string;
    key: string;
    value: any;
  }): Promise<IVariable<any>> {
    let res = await axios.post<IVariable<any>>(`${apiUrl}`, {
      r: restaurantId,
      b: branchId,
      cat: category,
      key,
      value,
    });
    return res.data;
  }
}
